import React, { useState, useEffect, useRef } from "react";
import Tooltip from "@material-ui/core/Tooltip";
import { withStyles } from "@material-ui/core/styles";

const BlackTooltip = withStyles(() => ({
  tooltip: {
    maxWidth: "200px",
    backgroundColor: "#3F3F51",
    fontFamily: "Poppins_Medium",
    fontSize: "13px",
    padding: "8px 17px"
  }
}))(Tooltip);

export function GroupRender({ rowData, rowIndex, t }) {
  const [disableHover, setDisableHover] = useState(true);
  const textContainer = useRef(null);

  useEffect(() => {
    if (
      textContainer.current &&
      textContainer.current.offsetWidth < textContainer.current.scrollWidth
    ) {
      setDisableHover(false);
    }
  }, [])

  const groupeName =
    rowData?.groupsName ? rowData?.groupsName : t("Aucun");

  return (
    <div
      className="arh-p-0 arh-font-poppins arh-font-medium arh-text-xs arh-text-darkGreyColor hover:!arh-text-darkGreyColor"
    >
      <BlackTooltip
        placement="top"
        title={groupeName}
        disableHoverListener={disableHover}
      >
        <span
          className={
            "arh-block arh-text-ellipsis arh-overflow-hidden groupeName" +
            rowIndex
          }
          ref={textContainer}
        >
          {groupeName}
        </span>
      </BlackTooltip>
    </div>
  );
}
